module.exports = __webpack_public_path__ + "static/media/detail_0018_t.d18779b9.jpg";